// Footer.jsx
import React from 'react';
import '../css/footer.css';

const Footer = () => {
  return (
    <>
      <div className="sponsors-section">
        <div className="sponsors-container">
          <div className="sponsors-scroll">
            {/* 첫 번째 스폰서 그룹 */}
            <div className="sponsors-group">
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
            </div>
            {/* 두 번째 스폰서 그룹 (무한 스크롤용 복제) */}
            <div className="sponsors-group">
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
              <div className="sponsor-item"></div>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="footer">
        {/* 기존 푸터 내용은 동일하게 유지 */}
        <div className="footer-content">
          <div className="footer-section">
            <h3>소개</h3>
            <p>소개</p>
          </div>
          
          <div className="footer-section">
            <h3>빠른 링크</h3>
            <ul>
              <li><a href="/">홈</a></li>
              <li><a href="/community">커뮤니티</a></li>
              <li><a href="/news">뉴스</a></li>
              <li><a href="/monthly">월간지</a></li>
              <li><a href="/event">소식</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>자주 찾는 메뉴</h3>
            <ul>
              <li><a href="/experts">익스퍼트 신청</a></li>
              <li><a href="/community/write/new">글쓰기</a></li>
              <li><a href="/admin">관리자 도구</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>연락처</h3>
            <p>Tel: 010-2282-8304</p>
            <p>Email: </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 천천히 아름다운 에너지. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;